import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService, FacebookApiresponceObject, ResponseObject } from './auth.service';
import { ServiceBase } from './service.base';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
// import { SocailPostApiResponce, SoicalPost } from '../models/viewartistproductresponse.model';
import { FacebookProfie, FacebookSocialPost, SocialPost, SocialPostData, SoicalPost } from 'src/app/models/socialpost.model';



@Injectable({
  providedIn: 'root'
})
export class SocialPostService extends ServiceBase{
  public api = '/SocialMedia';

  constructor(private http: HttpClient,
    authService: AuthService) { 
      super(authService);
  }

  public getSocailPost(productId: string): Observable<SocialPost[]> {
    var httpOptions = this.RequestHeaders();
    const method: string = '/fetchAllPosts/';
    const url: string = environment.BASE_API_PATH + this.api + method + productId;
    return this.http.get<SocialPost[]>(url, httpOptions);
  }
  public getAllSocailPost(productId?: string | null, filterUserId?: string | null): Observable<SocialPost[]> {
    const httpOptions = this.RequestHeaders();
    var method: string = '/fetchAllPostsOfCurrentUser';
    const url: string = environment.BASE_API_PATH + this.api + method;
    const requestBody = {
      productId: productId ? productId : null,
      filterUserId: filterUserId ? filterUserId : null
    };
    console.log(requestBody);
    return this.http.post<SocialPost[]>(url,requestBody , httpOptions);
  }


  public saveSocialPost(productId: string, socialPost: SoicalPost): Observable<ResponseObject> {
    var httpOptions = this.RequestHeaders();
    const method: string = '/PostOnFacebookPage/';
    const url: string = environment.BASE_API_PATH + this.api + method + productId;
    return this.http.post<ResponseObject>(url,socialPost, httpOptions);
  }

  public getPostData(): Observable<FacebookApiresponceObject[]>{
    var httpOptions = this.RequestHeaders();
    const method: string = '/FetchConnectedFacebookAccount/';
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.get<FacebookApiresponceObject[]>(url, httpOptions);
  }

  public getFacebookProfile(AccountId: string | undefined): Observable<FacebookProfie[]>{
    var httpOptions = this.RequestHeaders();
    const method: string = '/FetchConnectedFacebookAccount/' + AccountId;
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.get<FacebookProfie[]>(url, httpOptions);
  }

  public getInstagramProfile(AccountId: string | undefined): Observable<FacebookProfie[]>{
    var httpOptions = this.RequestHeaders();
    const method: string = '/FetchConnectedInstagramAccount/' + AccountId;
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.get<FacebookProfie[]>(url, httpOptions);
  }

  public getSocialAccountsData(AccountOf: string): Observable<any[]>{
    var httpOptions = this.RequestHeaders();
    const method: string = '/FetchConnectedFacebookOrInstagramAccounts/' + AccountOf;
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.get<any[]>(url, httpOptions);
  }

  public logInWithFacebook(): Observable<ResponseObject>{
    var httpOptions = this.RequestHeaders();
    const method: string = '/LoginWithFacebook';
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.get<ResponseObject>(url, httpOptions);
  }

  public loginWithInstagram(): Observable<ResponseObject>{
    var httpOptions = this.RequestHeaders();
    const method: string = '/LoginWithInstagram';
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.get<ResponseObject>(url, httpOptions);
  }

  public onSocialAccountsCallBack(code: string,state: string): Observable<ResponseObject>{
    var httpOptions = this.RequestHeaders();
    const method: string = '/store-token';
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.post<ResponseObject>(url,{ Code: code, State: state }, httpOptions);
  }
  
  public onGetSocialAccounts(IsActived: boolean) : Observable<SocialPostData[]>{
    var httpOptions = this.RequestHeaders();
    const method: string = '/ConnectedSocialAccounts/' + IsActived;
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.get<SocialPostData[]>(url, httpOptions);
  }

  public onGetConnectedSocialAccounts() : Observable<SocialPostData[]>{
    var httpOptions = this.RequestHeaders();
    const method: string = '/ConnectedSocialAccounts';
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.get<SocialPostData[]>(url, httpOptions);
  }

  public onGetAllConnectedSocialAccounts(IsActivated: boolean) : Observable<SocialPostData[]>{
    var httpOptions = this.RequestHeaders();
    const method: string = '/FetchConnectedAllSocialAccounts/' + IsActivated;
    const url: string = environment.BASE_API_PATH + this.api + method;
    console.log(url)
    return this.http.get<SocialPostData[]>(url, httpOptions);
  }

  public onGetFacebookAndInstagramAccount(AccountOf: string) : Observable<SocialPostData[]>{
    var httpOptions = this.RequestHeaders();
    const method: string = '/FetchConnectedFacebookOrInstagramAccounts/' + AccountOf;
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.get<SocialPostData[]>(url, httpOptions);
  }

  public onDeactiveAccount(AccountId : string,AccountOf: string): Observable<ResponseObject>{
    var httpOptions = this.RequestHeaders();
    const method: string = '/Disconnect-Account/' + AccountId + '/' + AccountOf;
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.post<ResponseObject>(url,{}, httpOptions);
  }

  public onReactiveAccount(AccountId : string,AccountOf: string): Observable<ResponseObject>{
    var httpOptions = this.RequestHeaders();
    const method: string = '/Reactivate-Account/' + AccountId + '/' + AccountOf;
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.post<ResponseObject>(url,{}, httpOptions);
  }

  public onReconnectAccount(AccountId : string,AccountOf: string): Observable<ResponseObject>{
    var httpOptions = this.RequestHeaders();
    const method: string = '/Reconnect-Account/' + AccountId + '/' + AccountOf;
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.post<ResponseObject>(url,{}, httpOptions);
  }

  public onFacebookPost(productId: string, socialPost: SoicalPost): Observable<ResponseObject>{
    var httpOptions = this.RequestHeaders();
    const method: string = '/PostOnFacebookPage/' + productId;
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.post<ResponseObject>(url,socialPost, httpOptions);
  }

  public onInstagramPost(productId: string, socialPost: SoicalPost): Observable<ResponseObject>{
    var httpOptions = this.RequestHeaders();
    const method: string = '/PostOnInstagram/' + productId;
    const url: string = environment.BASE_API_PATH + this.api + method;
    return this.http.post<ResponseObject>(url,socialPost, httpOptions);
  }

}

export class FilterSocialPostApi {
  productId?: string | null;
  filterUserId?: string | null;
}
